import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
/**
 * Displays "Draft Order" text on Order Flow if it's a draft flow
 *
 * @param text
 * @returns
 */
export const DraftOrderFlowText = ({ text }) => {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    return (_jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", position: "sticky", zIndex: "2", bottom: mobile ? "10%" : "7%" }, { children: [_jsx(Typography, { children: text }), _jsx(Typography, { children: text })] })));
};
